import type { FC } from 'react'

import { useAdminUser } from '@repo/common/queries/admin/user/admin_user_queries'

import classNames from './TowerUserLink.module.css'

interface TowerUserLinkProps {
  userId: string
  displayId?: boolean
}

export const TowerUserLink: FC<TowerUserLinkProps> = ({
  userId,
  displayId = true,
}) => {
  const { data, isLoading, error } = useAdminUser(userId)

  if (isLoading) {
    return <div className={classNames.user_link_card}>Loading user...</div>
  }

  if (error || !data) {
    return <div className={classNames.user_link_card}>Error loading user</div>
  }

  const { name, email, uuid, image } = data

  // Get initials for avatar if no image is available
  const getInitials = (): string => {
    if (!name) return '?'
    return name
      .split(' ')
      .map((part: string) => part[0])
      .join('')
      .toUpperCase()
      .substring(0, 2)
  }

  return (
    <div className={classNames.user_link_card}>
      <div className={classNames.user_avatar}>
        {image ? (
          <img src={image} alt={name || 'User'} width="40" height="40" />
        ) : (
          getInitials()
        )}
      </div>
      <div className={classNames.user_info}>
        <div className={classNames.user_name}>{name || 'Unknown User'}</div>
        {email && <div className={classNames.user_email}>{email}</div>}
        {displayId && uuid && (
          <div className={classNames.user_uuid}>{uuid}</div>
        )}
      </div>
    </div>
  )
}
